'use strict';

const _=require('pulsar-utils/dist-es6/_');
const TimeInterval=require('pulsar-utils/dist-es6/timeInterval');
const timespan=require('pulsar-utils/dist-es6/time/timespan');
const{DataSet,Timeline}=require('vis-timeline');
const fastdom=require('fastdom');
const FlightViewModel=require('../../../../dist-es6/client/viewModels/flightViewModel');
const FlightMonitorPersonViewModel=require('../../../../dist-es6/client/viewModels/flightMonitorPersonViewModel');
const Formatters=require('../../../../dist-es6/client/formatters');
const{ScheduleRowDirectiveController}=require('../../../../dist-es6/client/directives/scheduleRowDirective/scheduleRowDirective');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');

const MinorLabelAxisHeight=23;
const MajorMinorLabelAxisHeight=44;
const ScheduleRowHeight=41;

const DefaultMaxSchedulesToDisplay=Infinity;let

MultiForecastRowDirective=class MultiForecastRowDirective extends BaseControllerBackedDirective{
get template(){return''}

get objectBindings(){
return[
'forecastSchedules',
'selectedSchedule',
'currentTime',
'axisBounds',
'incidentTypesByCode',
'maxSchedulesToDisplay',
'timelineOptions',
'rangeChangeHandler',
'visibleItems',
'visibleBounds',
'enableZoomButtons',
'timeZoneOverride'];

}

get $inject(){return['$scope','$timeout','$element','$animate','$compile','timeZoneService','scheduleRowScrollingService','timeFormattingService','userService','fatigueMeterTypeContentProviderService']}

get controller(){return MultiForecastRowController}};let


MultiForecastRowController=class MultiForecastRowController extends ScheduleRowDirectiveController{
constructor($scope,$timeout,$element,$animate,$compile,timeZoneService,scheduleRowScrollingService,timeFormattingService,userService,fatigueMeterTypeContentProviderService){
super($scope,$timeout,$element,$animate,timeZoneService,scheduleRowScrollingService);
this.selectedSchedule=this.selectedSchedule||null;
this.maxSchedulesToDisplay=this.maxSchedulesToDisplay||DefaultMaxSchedulesToDisplay;
this._timeFormattingService=timeFormattingService;
this._userService=userService;
this._contentProvider=fatigueMeterTypeContentProviderService;

this.showZoomButtons=!!this.enableZoomButtons;
this.showJumpToPresentButton=_.get(this.timelineOptions,'moveable',!1)===!0;

if(this.maxSchedulesToDisplay===Infinity){
console.warn('[MultiForecastRowController] maxSchedulesToDisplay is "Infinity" and should be limited to reduce likelihood of performance impact.');
}

this._$compile=$compile;
this.zoomIn=this._zoomIn.bind(this);
this.zoomOut=this._zoomOut.bind(this);
this.jumpToPresent=this._jumpToPresent.bind(this);
this.rangeChangeHandler=this.rangeChangeHandler||_.noop;
}

_setupTimeline(){
super._setupTimeline();

const timelineOptions={
orientation:'top',
margin:16,
showCurrentTime:!0,
showMinorLabels:!0,
format:{
minorLabels:(date,scale,step)=>{
const zonedMoment=this._momentWithTimeZoneForTimeline(date);
const format=this._timeFormattingService.safeUse24HourTimelineSetting?
'HH:mm':
zonedMoment.hours()%12==0?
'hA':
'h:mm';

return zonedMoment.format(format);
}}};



if(_.exists(this.timelineOptions)){
_.assign(timelineOptions,this.timelineOptions);
}

this._timeline.setOptions(timelineOptions);

this._resetCurrentTime();

this._timelineElement=angular.element(this._$element).find('> .vis-timeline');

let additionalMarkup='';

additionalMarkup+=`<div id="group-outline" class="group-outline"></div>`;

additionalMarkup+=`<div id="selected-group-outline" class="group-outline selected"></div>`;

if(this.showZoomButtons){
const zoomButtonElement=this._$element.find('#zoom-buttons');
if(!zoomButtonElement.length){
additionalMarkup+=`<div id="zoom-buttons">
                    <button class="zoom-in" pulsar-while-pressed="controller.zoomIn" title="Zoom In">+</button>
                    <button class="zoom-out" pulsar-while-pressed="controller.zoomOut" title="Zoom Out">&mdash;</button>
                </div>`;
}
}
if(this.showJumpToPresentButton){
const jumptToPresentButtonElement=this._$element.find('#jump-to-present');
if(!jumptToPresentButtonElement.length){
additionalMarkup+=`<div id="jump-to-present-button" ng-class="{'current-time-visible': controller.isCurrentTimeInVisibleBounds === true }">
                    <button ng-click="controller.jumpToPresent($event)" title="Jump to Present"></button>
                </div>`;
}
}

this._timelineElement.append(additionalMarkup);

this._hoveredGroupOutlineElement=angular.element('#group-outline');
this._selectedGroupOutlineElement=angular.element('#selected-group-outline');

this._timeline.on('click',event=>{
if(this._isChangingRange===!0){
return;
}

this._$scope.$evalAsync(()=>{
const selectedSchedule=this.forecastSchedules[_.get(event,'group',-1)];
this.selectedSchedule=selectedSchedule||null;
this._moveElementToSchedule(this._selectedGroupOutlineElement,selectedSchedule,'selected');
});
});

if(_.get(this.timelineOptions,'verticalScroll')){
this._timeline.on('scroll',()=>{
if(!_.exists(this.selectedSchedule)){
return;
}

this._$scope.$evalAsync(()=>{
this._moveElementToSchedule(this._selectedGroupOutlineElement,this.selectedSchedule,'selected');
});
});
}

const debouncedUpdateHoveredGroup=_.debounce((event,source)=>{
if(!this._hoveredGroupOutlineElement){
return;
}

if(_.exists(event.group)){
this._moveElementToSchedule(this._hoveredGroupOutlineElement,this.forecastSchedules[_.get(event,'group',-1)],'hovered');
return;
}

if(event.currentTarget){
const _paths=_.compact([
..._.get(event,'originalEvent.path',[]),
..._.result(event,'originalEvent.composedPath',[]),
..._.get(event,'path',[]),
..._.result(event,'composedPath',[])]);


if(_paths.length===0||_paths.find(p=>_.get(p,'tagName')==='PULSAR-MULTI-FORECAST-ROW')!==void 0){
return;
}
}

this._hideElement(this._hoveredGroupOutlineElement,'hovered');
},6,{maxWait:6,leading:!0,trailing:!0});

this._timeline.on('changed',()=>{
this._resetCurrentTime();
this.visibleItems=new Set(this._timeline.getVisibleItems().map(id=>this._timelineDataById.get(id)));
this.visibleBounds=new TimeInterval(this._timeline.getWindow());
});

this._timeline.on('mouseMove',debouncedUpdateHoveredGroup);
angular.element(document).on('mousemove',debouncedUpdateHoveredGroup);

this._$scope.$on('$destroy',()=>{
this._timeline.off('click');
this._timeline.off('scroll');
this._timeline.off('mouseMove');

angular.element(document).off('mousemove',debouncedUpdateHoveredGroup);

this._destroyChildScopes();
});
}

_hideElement(element,classToRemove){
if(_.get(this.timelineOptions,'verticalScroll')){
fastdom.mutate(()=>{
const elements=angular.element(`.vis-group.${classToRemove},.vis-group-level-0.${classToRemove}`);
if(!elements.length){
return;
}
elements.removeClass(classToRemove);
});

return;
}

if(!_.exists(element)){
return;
}

fastdom.mutate(()=>{
element.css({display:'none'});
});
}

_moveElementToSchedule(element,group,classToToggle){
if(!_.exists(element)){
return;
}

if(!group){
this._hideElement(element,classToToggle);
return;
}

const index=(this.forecastSchedules||[]).indexOf(group);

if(!this.forecastSchedules||index===-1||index>=Math.min(this.forecastSchedules.length,this.maxSchedulesToDisplay)){
this._hideElement(element,classToToggle);
return;
}

fastdom.mutate(()=>{
if(_.get(this.timelineOptions,'verticalScroll')){
const oldGroupLabelElement=angular.element(`.vis-group-level-0.${classToToggle}:not(:nth-child(${index+1}))`);
const oldGroupTimelineElement=angular.element(`.vis-foreground .vis-group.${classToToggle}:not(:nth-child(${index+1}))`);

oldGroupLabelElement.removeClass(classToToggle);
oldGroupTimelineElement.removeClass(classToToggle);

const groupLabelElement=angular.element(`.vis-group-level-0:nth-child(${index+1})`);
const groupTimelineElement=angular.element(`.vis-foreground .vis-group:nth-child(${index+1})`);

groupLabelElement.addClass(classToToggle);
groupTimelineElement.addClass(classToToggle);

return;
}

let offset=_.get(this.timelineOptions,'verticalScroll')?(angular.element('.vis-panel.vis-left.vis-vertical-scroll').scrollTop()||0)-ScheduleRowHeight/2:0;

element.css({
display:'block',
transform:`translateY(${index*ScheduleRowHeight-offset}px)`});

});
}

_updateData(){
const groups=new DataSet([]);
const items=new DataSet([{
id:'unloaded-past-mask',
start:TimeInterval.Forever.start,
end:this.axisBounds.start,
type:'background',
className:'unloaded-past-mask'},

{
id:'past-mask',
start:this.axisBounds.start,
end:this.currentTime,
type:'background',
className:'past-mask'},

{
id:'unloaded-future-mask',
start:this.axisBounds.end,
end:TimeInterval.Forever.end,
type:'background',
className:'unloaded-future-mask'}]);



const numSchedulesToProcess=Math.min(this.forecastSchedules.length,this.maxSchedulesToDisplay);

if(!this.forecastSchedules||numSchedulesToProcess===0){
this._setTimelineData({groups,items});
return;
}

this._setTimelineData({groups,items});

for(let index=0;index<numSchedulesToProcess;index++){
groups.add({
id:index,
content:document.createRange().createContextualFragment(`
                <div class="person-label" layout="column">
                    <pulsar-current-duty-status person-view-model="controller.forecastSchedules[${index}]"><div class="current-status-icon">&nbsp;</div></pulsar-current-duty-status>
                    <a class="name" href="${this.forecastSchedules[index].viewSchedule({asString:!0})}" title="${this.forecastSchedules[index].name}">${this.forecastSchedules[index].name}</a>
                    ${this.forecastSchedules[index].timeOfLastPointBeforeTruncation?'<span class="is-stale" title="Invalid data detected."></span>':''}
                </div>
                `).children[0]});

}

this._timelineDataById=new Map;
const allItemData=Array(numSchedulesToProcess).fill(0).map((unused,index)=>this._getTimelineDataFor(this.forecastSchedules[index],index));
const itemDataChunks=_.chunk(allItemData,Math.max(Math.floor(numSchedulesToProcess/10),50));
for(let chunkIndex=0;chunkIndex<itemDataChunks.length;chunkIndex++){
const chunk=itemDataChunks[chunkIndex];
setTimeout(()=>{
fastdom.mutate(()=>_.attempt(()=>{
for(const itemData of chunk){
items.add(itemData);
}

if(chunk===_.last(itemDataChunks)){
this._$scope.$evalAsync(()=>{

this._setTimelineData({groups,items});
});
}
}));
},65*chunkIndex);
}
}

_updateHeight(){
if(this._automaticHeight){
this._timeline.setOptions({height:this._automaticHeight});
return;
}

const numSchedulesToProcess=Math.min(this.forecastSchedules.length,this.maxSchedulesToDisplay);

const axisHeight=_.get(this.timelineOptions,'showMajorLabels')?MajorMinorLabelAxisHeight:MinorLabelAxisHeight;

const height=_.get(this.timelineOptions,'height')?
this.timelineOptions.height-axisHeight:
axisHeight+(numSchedulesToProcess||1)*ScheduleRowHeight+'px';

this._timeline.setOptions({height});
}

_setTimelineData({groups,items}){
this._resetCurrentTime();
this._timeline.setData({groups,items});
this._updateHeight();

this._destroyChildScopes();
this._childScopes=new Set;

const currentDutyStatusElements=this._$element.find('pulsar-current-duty-status');

for(const el of currentDutyStatusElements){
const childScope=this._$scope.$new();
this._childScopes.add(childScope);

this._$compile(el)(childScope,compiled=>{
this._$scope.$evalAsync(()=>{
angular.element(el).replaceWith(compiled);
});
childScope.$on('$destroy',()=>{
compiled.remove();
});
});
}

if(this.showZoomButtons){
const zoomButtonElement=this._$element.find('#zoom-buttons');
this._$compile(zoomButtonElement)(this._$scope,compiled=>{
this._$scope.$evalAsync(()=>{
angular.element(zoomButtonElement).replaceWith(compiled);
});
this._$scope.$on('$destroy',()=>{
compiled.remove();
});
});
}

if(this.showJumpToPresentButton){
const jumptToPresentButtonElement=this._$element.find('#jump-to-present-button');
this._$compile(jumptToPresentButtonElement)(this._$scope,compiled=>{
this._$scope.$evalAsync(()=>{
angular.element(jumptToPresentButtonElement).replaceWith(compiled);
});
this._$scope.$on('$destroy',()=>{
compiled.remove();
});
});
}
}


_resetCurrentTime(){
this._timeline.setCurrentTime(this.currentTime);
this._timeline.currentTime.stop();
this.isCurrentTimeInVisibleBounds=_.exists(this.visibleBounds)&&this.visibleBounds.contains(this.currentTime);
}

_destroyChildScopes(){
if(this._childScopes){
for(const scope of this._childScopes){
scope.$destroy();
}
}
}

_setupWatchers(){
if(_.get(this.timelineOptions,'autoResize')){
this._$scope.$on('resize::resize',(...args)=>{
if(!this._timeline){
return;
}

fastdom.measure(()=>{
const containerHeight=angular.element('.feature-main').innerHeight();
const filterSectionHeight=angular.element('.filter-section').innerHeight();

this._automaticHeight=containerHeight-filterSectionHeight;

fastdom.mutate(()=>{
this._updateHeight();
});
});
});
}

this._$scope.$watch('controller.forecastSchedules',()=>{
this._moveElementToSchedule(this._selectedGroupOutlineElement,this.selectedSchedule,'selected');
this._redraw();
});

this._$scope.$watch('controller.timeZoneOverride',()=>this._redraw());
this._$scope.$watch('controller.selectedSchedule',()=>this._moveElementToSchedule(this._selectedGroupOutlineElement,this.selectedSchedule,'selected'));
}

_getTimelineDataFor(forecastSchedule,groupId){
const{
incidents=[],
scenario={},
schedule,
predictedWorkday,
visibleAlertRanges={past:{},future:{}},
alertRanges={past:{},future:{}},
combinedDuties,
currentDuty,
assessments=[],
alwaysDraw,
pastShifts}=
forecastSchedule;

let newData=[];

if(scenario&&visibleAlertRanges||alwaysDraw){
if(_.exists(predictedWorkday)){
newData.push({
id:'forecasted-duty',
start:predictedWorkday.start,
end:predictedWorkday.end,
className:`forecasted-duty`});

}

if(_.exists(currentDuty)){
newData.push({
id:'current-duty',
start:currentDuty.start,
end:currentDuty.end,
className:`current-duty`});

}

newData=newData.concat(
_getNamedRangesFrom(pastShifts,'past-shift'),

_getNamedRangesFrom(combinedDuties,'duty'),
_getNamedRangesFrom(_.compact([].concat(schedule.trips,scenario.trips,schedule.flights,scenario.flights)),'trip',forecastSchedule,this._timeFormattingService.safeUse24HourTimelineSetting),

_getNamedRangesFrom(scenario.sleep,'sleep'),

_getNamedRangesFrom(visibleAlertRanges.past.At,'at-threshold past'),
_getNamedRangesFrom(visibleAlertRanges.future.At,'at-threshold future'),

_getNamedRangesFrom(visibleAlertRanges.past.Above,'above-threshold past'),
_getNamedRangesFrom(visibleAlertRanges.future.Above,'above-threshold future'),

_getNamedRangesFrom(alertRanges.At,'at-threshold full'),
_getNamedRangesFrom(alertRanges.Above,'above-threshold full'),

incidents.map((d,i)=>({
id:`incident-${i}`,
type:'point',
title:`Incident: ${this.incidentTypesByCode[d.code].description}`,
start:d.time,
className:'incident incident-type-'+d.code.toLowerCase()+(d.time.getTime()>this.currentTime.getTime()?' future':'')})),



_.sortBy(assessments,a=>a.time.getTime()).map((a,i)=>({
id:`assessment-${i}`,
type:'point',
title:`${a.status}: ${a.reason}, ${this._timeFormattingService.timeInLocale(a.time,this.timeZone)}`,




start:a.time,
className:`assessment render-index-${i} assessment-reason-${_.kebabCase(a.reason)} assessment-status-${_.kebabCase(a.status)}`})));


}

const asTimelineData=newData.map(d=>_.assign(d,{group:groupId,id:groupId+'-'+d.id}));

for(const item of asTimelineData){
this._timelineDataById.set(item.id,item.data);
}

return newData;
}

_jumpToPresent($event){
if(!this._timeline||!this.rangeChangeHandler||!this.currentTime){
return;
}

if($event){
$event.preventDefault();
$event.stopPropagation();
}

const currentWindow=new TimeInterval(this._timeline.getWindow());
const offestFromStart=Math.min(currentWindow.duration.totalMilliseconds()/10,timespan.fromHours(12).totalMilliseconds());
const newWindow=TimeInterval.from(this.currentTime.getTime()-offestFromStart).spanning(currentWindow.duration);

this._$scope.$evalAsync(()=>{
this.rangeChangeHandler({
start:newWindow.start,
end:newWindow.end,
byUser:!0});


this._updateWindow(newWindow);
this.isCurrentTimeInVisibleBounds=!0;
});
}

_fireRangeChangeAndUpdateWindowState(newWindow=new TimeInterval(this._timeline.getWindow())){
if(!this._timeline||!this.currentTime){
return;
}

this._updateWindow(newWindow);

this.rangeChangeHandler({
start:newWindow.start,
end:newWindow.end,
byUser:!0});


this.isCurrentTimeInVisibleBounds=newWindow.contains(this.currentTime);
}

_zoomIn(){
if(!this._timeline){
return;
}

this._timeline.zoomIn(0.25,{duration:150},()=>this._fireRangeChangeAndUpdateWindowState());
}

_zoomOut(){
if(!this._timeline){
return;
}

this._timeline.zoomOut(0.25,{duration:150},()=>this._fireRangeChangeAndUpdateWindowState());
}

get currentBounds(){
return _.pick(this.axisBounds,['start','end']);
}};


function _getNamedRangesFrom(data,name,srcViewModel,use24HourFormat=!1){
if(!data){
return[];
}

const flightFormatter=use24HourFormat?Formatters.flightLabel_24Hour():Formatters.flightLabel();

return data.map((d,i)=>{
const additionalClasses=[];
let title=void 0;
if(d instanceof FlightViewModel&&srcViewModel instanceof FlightMonitorPersonViewModel){
const thresholdStatusClassObject=Formatters.classFromThresholdStatus(srcViewModel.getThresholdStatusForFlight(d));
for(const key in thresholdStatusClassObject){
additionalClasses.push(key);
}

title=flightFormatter(d).replace('\n','<br />');
}

return{
id:`${name}-${i}`,
start:d.start,
end:d.end,
className:[name,...additionalClasses].join(' '),
title,
data:d};

});
}

module.exports=MultiForecastRowDirective;
//# sourceMappingURL=multiForecastRowDirective.js.map
